(() => {
  'use strict';
  
  const SECTION = document.querySelector('.nextdev--video-reviews-carousel');
  const SWIPER = SECTION.querySelector('.swiper');
  const videos = SWIPER.querySelectorAll('video');
  const videosPause = SWIPER.querySelectorAll('.nextdev--video-reviews-carousel--video__media--pause');
  const videosMute = SWIPER.querySelectorAll('.nextdev--video-reviews-carousel--video__media--mute');

  const swiperInstance = new Swiper(SWIPER, {
    slidesPerView: 'auto',
    spaceBetween: 12,
    loop: true,
    centeredSlides: false,

    breakpoints: {
      750: {
        centeredSlides: true,
      },
    },

    on: {
      init: function () {
        setupVideoObserver();

        const video = SWIPER.querySelector('.swiper-slide-active video');

        if (video != null) {
          const slide = video.closest('.swiper-slide');
          const videoPause = slide.querySelector('.nextdev--video-reviews-carousel--video__media--pause');
          videoPause.setAttribute('data-paused', 'false');
            
          video.play().catch(err => {
            videoPause.setAttribute('data-paused', 'true');
            console.warn('Video play failed:', err);
          });
        }
      },
      slideChange: function () {
        pauseNonActiveVideos();

        const activeSlide = this.slides[this.activeIndex];
        const activeSlideVideo = activeSlide.querySelector('video');

        if (activeSlideVideo != null) {
          const videoPause = activeSlide.querySelector('.nextdev--video-reviews-carousel--video__media--pause');
          videoPause.setAttribute('data-paused', 'false');

          activeSlideVideo.play().catch(err => {
            videoPause.setAttribute('data-paused', 'true');
            console.warn('Video play failed:', err);
          });
        }
      },
    },
      
    mousewheel: {
      forceToAxis: true
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:block:select', (event) => {
      const blockId = event.detail.blockId;

      const slideIndex = [...SWIPER.querySelectorAll('.swiper-slide')].findIndex(
        el => el.dataset.blockId === blockId
      );
      
      if (slideIndex !== -1) {
        swiperInstance.slideTo(slideIndex);
      }
    });
  }

  if (videosPause.length > 0) {
    videosPause.forEach((videoPause) => {
      videoPause.addEventListener('click', () => {
        const slide = videoPause.closest('.swiper-slide');
        const video = slide.querySelector('video');
        const paused = videoPause.dataset.paused;

        if (paused == 'true') {
          video.play();
          videoPause.setAttribute('data-paused', 'false');
        } else {
          video.pause();
          videoPause.setAttribute('data-paused', 'true');
        }
      });
    });
  }

  if (videosMute.length > 0) {
    videosMute.forEach((videoMute) => {
      videoMute.addEventListener('click', () => {
        const slide = videoMute.closest('.swiper-slide');
        const video = slide.querySelector('video');
        const muted = videoMute.dataset.muted;

        if (muted == 'true') {
          video.muted = false;
          videoMute.setAttribute('data-muted', 'false');
        } else {
          video.muted = true;
          videoMute.setAttribute('data-muted', 'true');
        }
      });
    });
  }

  function pauseNonActiveVideos() {
    const slides = SWIPER.querySelectorAll('.swiper-slide video');
    slides.forEach((video, index) => {
      if (index !== SWIPER.activeIndex) {
        const slide = video.closest('.swiper-slide');
        const videoPause = slide.querySelector('.nextdev--video-reviews-carousel--video__media--pause');

        video.pause();
        videoPause.setAttribute('data-paused', 'true');
      }
    });
  }

  function setupVideoObserver() {
    const observerOptions = {
      threshold: 0.5, // 50% of video visible
    };

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        const slide = video.closest('.swiper-slide');
        const videoPause = slide.querySelector('.nextdev--video-reviews-carousel--video__media--pause');

        if (entry.isIntersecting) {
          if (slide.classList.contains('swiper-slide-active')) {
            videoPause.setAttribute('data-paused', 'false');

            video.play().catch((err) => {
              videoPause.setAttribute('data-paused', 'true');
              console.warn('Video play failed:', err);
            });
          }
        } else {
          video.pause();
          videoPause.setAttribute('data-paused', 'true');
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, observerOptions);

    videos.forEach((video) => {
      const slide = video.closest('.swiper-slide');
      const videoMute = slide.querySelector('.nextdev--video-reviews-carousel--video__media--mute');

      video.muted = true;
      videoMute.setAttribute('data-muted', 'true');

      video.addEventListener('ended', () => {
        swiperInstance.slideNext();
      });

      observer.observe(video);
    });
  }
})();
